import React from "react";
import _ from 'lodash'


const ProClientDuration = ({index, assignment, performAction, totalAssignments})=>{
  
     if(_.get(assignment.occupantType, "code") === "CLIENT"){
            return  <div id={`Duration-${assignment.assignmentId}`}  className={_.gt(totalAssignments, 1)?_.isEqual(index+1, totalAssignments)?"p-mb client-date" :"p-mb-3 client-date ":"p-mb client-date"} >
                    <span >{assignment.startDate}</span><span> - </span> <span>{assignment.endDate}</span>
            </div> 
        }else {            
            return <div id={`Duration-${assignment.assignmentId}`} className={_.gt(totalAssignments, 1)?_.isEqual(index+1, totalAssignments)?"p-mb client-date" :"p-mb-3 client-date ":"p-mb client-date"}>
                 <span>{assignment.startDate}</span><span> - </span> <span>{assignment.endDate}</span>
            </div>
        }        
   

}

export default ProClientDuration;